import Grid from '@material-ui/core/Grid';
import { LargeSecondaryButton } from '@worthy-npm/clarity';
import React from 'react';
import I18n from 'lib/i18n/i18n';
import {
    MIN_SIMILAR_ITEMS_TO_SHOW,
    ITEM_TYPE_TO_RECENTLY_SOLD_ITEMS_URL_MATCH
} from '../helpers/ApplicationHelper';

import SimilarItems from "./similarItems";

class SimilarItemsContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            items,
            goTo,
            item,
            isSimplified,
            userActionsCb,
            version
        } = this.props;

        const MIN_SOLD_COUNT_THRESHOLD = 10;
        let showSimilarItems = items && items.length >= MIN_SIMILAR_ITEMS_TO_SHOW;
        let showSoldCount =  item.sold_last_x_days_count && item.sold_last_x_days_count >= MIN_SOLD_COUNT_THRESHOLD;
        let itemTypeName = item.item_type === 'ring' ? 'diamond rings' : 'loose diamonds';
        if (showSimilarItems) {
            userActionsCb('Similar items has been presented', item.id, version);
        }

        return showSimilarItems ? <Grid item xs={12}>
            <div className={ `similar-items-section ${ items.length < 4 ? 'centered' : '' }` }>
                {
                    isSimplified ? null : <h2 className='listing-title h2'> {I18n.getString('listingPage::similarItemsTitle')}</h2>
                }
                {
                    showSoldCount ? <div className={'sold-last-x-days'}>
                        <b>{item.sold_last_x_days_count} {itemTypeName}</b> sold on our marketplace in the past week
                            { isSimplified ? '. Here are some of them: ' : null }
                    </div> : null
                }
                <SimilarItems items={items} hideSoldFor={true} goTo={goTo} item={item}/>
                {
                    isSimplified ? null : <LargeSecondaryButton
                            text={ I18n.getString('listingPage::moreSimilar') }
                            disabled={false}
                            click={(stopAnimation) =>
                                goTo(`/about/recent-deals/${ ITEM_TYPE_TO_RECENTLY_SOLD_ITEMS_URL_MATCH[item.item_type] || '' }?item=${item.id}`, '«More similar items» buttons clicked', item.id, false, stopAnimation)}
                        />
                }
            </div>
        </Grid> : null
    }
}

export default SimilarItemsContainer;
